<template>
  <div id="app">
    <div>
      <b-navbar toggleable="lg justify-content-end">
        <b-navbar-toggle target="nav-collapse" :class="$route.path === '/' ? 'toggle-home' : ''"></b-navbar-toggle>
        <b-collapse id="nav-collapse" :class="$route.path === '/' ? 'padding-home' : ''" is-nav>
          <b-navbar-nav class="mx-auto" :class="$route.path === '/' ? 'navbar-dark' : ''">
            <b-nav-item to="/">Главная</b-nav-item>
            <b-nav-item to="/ekran">Выходные сведения</b-nav-item>
            <b-nav-item to="/drafters">От составителей</b-nav-item>
            <b-nav-item-dropdown text="Сотрудники">
              <div v-if="$store.getters.PORTRETS">
                <div v-for="(port, index1) in $store.getters.PORTRETS" :key="'menu-parts' + index1">
                  <b-nav-item disabled><span v-html="$store.getters.PARTS[index1]" /></b-nav-item>
                  <div v-for="(portret, index) in port" :key="index">
                    <b-dropdown-item :class="portret[0] == $route.params.persona ? 'active' : ''"
                      :to="'/about/' + portret[0]">{{ $store.getters.FIO[portret[1]][0] }} {{
          $store.getters.FIO[portret[1]][1] }}</b-dropdown-item>
                  </div>
                </div>
              </div>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
    <router-view />
    <FooterC />
  </div>
</template>
<script>
import FooterC from '@/components/FooterComponent.vue'
export default {
  created() {
    this.getJSON();
  },
  methods: {
    getJSON() {
      if (this.$store.getters.PORTRETS === null) {
        this.axios
          .get('data/main/main.json')
          .then(response => (
            this.$store.commit('portretsSet', response.data.portrets),
            this.$store.commit('partsSet', response.data.parts),
            this.$store.commit('fioSet', response.data.fio)
          ))
          // .catch(function (error) {
          //   console.log(error);
          // })
          ;
      }
    },
  },

  components: {
    FooterC
  },
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  /* padding: 30px; */
  z-index: 2;
  font-size: 20px;
}

nav a {
  font-weight: bold;
  color: #5d6369;

}

nav a.router-link-exact-active {
  color: #2b2b2b;
}

.padding-home .b-nav-dropdown {
  padding-bottom: 0px;
}

@media (max-width: 992px) {
  .padding-home .b-nav-dropdown {
    padding-bottom: 74px !important;
  }
}






/* .navbar-collapse {
  padding-bottom: 0;
} */

/* .navbar-collapse.show.padding-home {
    transition: all .7s ease-out;
} */
/* .padding-home {
     padding-bottom: 132px;
} */
.nav-link.disabled,
.nav-link:disabled {
  color: teal !important;
  padding-left: 10px;
  font-weight: bold;
}

.navbar-toggler {
  margin: calc(var(--bs-navbar-toggler-padding-y) + 5px) calc(var(--bs-navbar-toggler-padding-x) + 5px) !important;
}

.show.padding-home .nav-link {
  color: black;
}

.padding-home .nav-link {
  color: white;
}

li .active {
  background-color: rgb(203, 229, 229);
}

/* .navbar-toggler.toggle-home,
.toggle-home .navbar-toggler-icon {
    color: white !important;
 } */
</style>
